import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import salesServiceOrderService from '../../../services/salesServiceOrderService';
import SalesServiceOrderPrintDocument from '../../../components/Ventas/SalesServiceOrderPrintDocument';
import EntryGuidePrintButton from '../../../components/EntryGuides/EntryGuidePrintButton';
import {
  ENTRY_GUIDE_PRINT_PAGE_STYLES,
  ENTRY_GUIDE_PRINT_STYLES,
} from '../../../components/EntryGuides/entryGuidePrintStyles';
import { downloadSalesServiceOrderPdf } from '../../../utils/generateSalesServiceOrderPdf';

const PrintVentasServiceOrder = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pdfLoading, setPdfLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await salesServiceOrderService.getServiceOrder(id);
        if (response.success) setOrder(response.data);
      } catch (error) {
        console.error('Error al cargar orden de servicio:', error);
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id]);

  const handleDownloadPdf = async () => {
    if (!order || pdfLoading) return;
    setPdfLoading(true);
    try {
      await downloadSalesServiceOrderPdf(order);
    } catch (error) {
      console.error('Error al generar PDF:', error);
      alert(error?.message || 'No se pudo generar el PDF');
    } finally {
      setPdfLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto mb-4" />
          <p className="text-gray-600">Cargando orden de servicio…</p>
        </div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-red-600 text-lg">Orden de servicio no encontrada</p>
      </div>
    );
  }

  return (
    <div className="eg-print-root">
      <style>{`${ENTRY_GUIDE_PRINT_PAGE_STYLES}${ENTRY_GUIDE_PRINT_STYLES}`}</style>

      <div className="print-actions no-print">
        <EntryGuidePrintButton variant="button" onClick={() => window.print()} />
        <button
          type="button"
          onClick={handleDownloadPdf}
          disabled={pdfLoading}
          className="px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium shadow-md transition-colors disabled:opacity-60"
        >
          {pdfLoading ? 'Generando PDF…' : 'PDF'}
        </button>
        <button
          type="button"
          onClick={() => window.close()}
          className="px-5 py-2.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 font-medium shadow-md transition-colors"
        >
          Cerrar
        </button>
      </div>

      <SalesServiceOrderPrintDocument order={order} />
    </div>
  );
};

export default PrintVentasServiceOrder;
